// extracted by mini-css-extract-plugin
export var author = "faq-module--author--bd66e";
export var category = "faq-module--category--08e19";
export var faq = "faq-module--faq--c0ff0";
export var faqContent = "faq-module--faqContent--742f0";
export var faqQuestion = "faq-module--faqQuestion--23099";
export var faqQuestionIcon = "faq-module--faqQuestionIcon--070c0";
export var faqQuestionText = "faq-module--faqQuestionText--eb1b8";
export var headline = "faq-module--headline--ae98e";
export var headlinePost = "faq-module--headline-post--1b65a";
export var isOpen = "faq-module--isOpen--065ae";
export var paragraph = "faq-module--paragraph--3cd7a";